import * as yup from 'yup'

export const validateUpdateDirectoryCategories = yup.object().shape({
    name:yup
    .string()
    .min(2, 'El NOMBRE debe tener más de 2 caracteres'),
})